import type { InputBaseProps } from "@components/ngg";
import { Input as NGGInput } from "@components/ngg";
import { forwardRef } from "react";

import { cn } from "@/lib/utils";

type InputBasePropsWithPassword = InputBaseProps & {
  passwordrules?: string;
};

const Input = forwardRef<HTMLInputElement, InputBasePropsWithPassword>(
  ({ label, id, classNames, endAdornment, required, ...props }, ref) => {
    const isInvalid = props["aria-invalid"] === true;
    return (
      <NGGInput
        ref={ref}
        required={required}
        placeholder={label}
        endAdornment={
          <>
            {label ? (
              <label
                htmlFor={id}
                className={cn(
                  "pointer-events-none absolute top-2.5 bottom-2.5 left-4 text-base text-gray-300",
                  "transition-transform peer-focus:-translate-y-1.5 peer-focus:text-sm",
                  "peer-[&:not(:placeholder-shown)]:-translate-y-1.5 peer-[&:not(:placeholder-shown)]:text-sm",
                  isInvalid && "text-error",
                  classNames?.label,
                )}
              >
                {label}
                {required && "*"}
              </label>
            ) : null}
            {endAdornment}
          </>
        }
        classNames={{
          ...classNames,
          hint: cn("pl-4", isInvalid && "text-error", classNames?.hint),
          input: cn(
            "peer h-10 w-full border border-black px-4 pb-1.5 pt-4 lg:text-lg text-base",
            "bg-white placeholder:text-transparent",
            isInvalid && "border-error",
            classNames?.input,
          ),
        }}
        {...props}
      />
    );
  },
);

export default Input;
